import { render } from "./Card.vue?vue&type=template&id=48697ea2&ts=true"
import script from "./Card.vue?vue&type=script&lang=ts"
export * from "./Card.vue?vue&type=script&lang=ts"

import "./Card.vue?vue&type=style&index=0&id=48697ea2&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__